import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Tabs,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";
import Footer from "../../components/Home/Footer";
import style from "../../components/TradeActivity/style";
import Layout from "../../components/Layout/Layout";
import { useMutation } from "react-query";
import fetcher from "../../src/dataProvider";
import { useSelector } from "react-redux";
import auth from "../../components/Layout/util/auth";
import eventBus from "../../util/eventBus";
import { CACHED_API_URL } from "../../src/constant/appConstants";
import { GridExpandMoreIcon } from "@mui/x-data-grid";
import { songPageGTMCTAClick } from "../../util/gtmutil";
import { useRouter } from "next/router";

const Index = () => {
  const [childvalue, setChildValue] = useState(0);
  const [tradingList, setTradingList] = useState();
  const { country_code } = useSelector((state) => state.layout);
  const [user, setUser] = useState(auth());
  const [isMobile, setIsMobile] = useState(true);
  const r = auth();
  var router = useRouter();

  const handleChildTabs = (event, newValue) => {
    songPageGTMCTAClick(
      r,
      "ctaClicks",
      "Trade Activity",
      event?.target?.innerText,
      "loggedIn",
      "Guest",
      "Market Page"
    );
    if (event?.target?.dataset?.tradingvalue) {
      checkTradingListNFTs(event?.target?.dataset?.tradingvalue);
    }
    setChildValue(newValue);
  };
  const handleWindowSizeChange = () => {
    setIsMobile(window.innerWidth < 768);
  };

  useEffect(() => {
    eventBus.on("userLoggedIn", () => {
      checkAuth();
    });
    handleWindowSizeChange();
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  useEffect(() => {
    if (!user?.token) {
      eventBus.dispatch("openLoginModal", { function_name: "unique" });
    }
  }, [user]);

  const checkAuth = () => {
    setUser(auth());
  };

  const { mutate: checkTradingListNFTs } = useMutation(
    (data) =>
      fetcher.get(
        `${CACHED_API_URL}/v1/nft/get-tiers-price-change-list?page=${data}`
      ),
    {
      onSuccess: (res) => {
        setTradingList(res?.data);
      },
      onError: (error) => {
        alert(error?.response?.data?.message);
      },
    }
  );

  useEffect(() => {
    if (user?.token) {
      checkTradingListNFTs("all");
    }
  }, [user?.token]);
  const AllNftTradingData = (data) => {
    const handleBuyNft = (item) => {
      songPageGTMCTAClick(
        r,
        "ctaClicks",
        "Trade Activity",
        "Buy btn",
        "loggedIn",
        "Guest",
        item?.tierName
      );
      if (typeof window != "undefined") {
        localStorage.setItem("nftAction", "BuyNFT");
        localStorage.setItem("is_tradable", item?.isTradableNft);
        localStorage.setItem("tokenName", item?.tierName);
        localStorage.setItem("tierId", item?.tierId);
        localStorage.setItem("tokenCategory", item?.slug);
        localStorage.setItem("tokenPrice", item?.currentPrice);
        router?.push({
          pathname: "/payment/BuyTradeNft",
          query: {
            tier_id: item?.tierId,
          },
        });
      }
    };
    const handleSellNow = (item) => {
      songPageGTMCTAClick(
        r,
        "ctaClicks",
        "Trade Activity",
        "Sell",
        "loggedIn",
        "Guest",
        item?.tierName
      );
      localStorage.setItem("nftAction", "SellNFT");
      router.push({
        pathname: "/payment/SellTradeNft",
        query: {
          tier_id: item?.tierId,
        },
      });
    };

    return (
      <Box sx={style.tabContentBoxPortfolio}>
        <Box sx={style.Trade__Activity}>
          {isMobile ? (
            <>
              {data?.AlltradingList?.map((item) => {
                return (
                  <Accordion sx={style.accordion} key={item?.tierId}>
                    <table sx={style.tableContainer} style={{ width: "100%" }}>
                      <tr>
                        <td
                          onClick={() => router?.push(item?.slug)}
                          style={{ cursor: "pointer" }}
                        >
                          <Box
                            component="img"
                            src={item?.defaultImageUrl}
                            style={{
                              width: "40px",
                              height: "40px",
                              borderRadius: "6px",
                              objectFit: "contain",
                            }}
                          />
                          <Typography
                            component="p"
                            style={{
                              display: "inline-block",
                              marginLeft: "15px",
                              color: "#fff",
                            }}
                          >
                            {item?.tierName}{" "}
                          </Typography>
                        </td>
                        <td
                          style={{
                            color: "#fff",
                          }}
                        >
                          {country_code == "IN" ? (
                            <>
                              ₹
                              {(
                                Math.round(item?.currentPrice * 80 * 100) / 100
                              ).toFixed(2)}
                            </>
                          ) : (
                            <>
                              $
                              {(
                                Math.round(item?.currentPrice * 100) / 100
                              ).toFixed(2)}
                            </>
                          )}
                        </td>
                        <td>
                          {item?.changePercent24Hr == 0 ? (
                            <Typography
                              style={{
                                color: "#fff",
                              }}
                            >
                              {Math.abs(item?.changePercent24Hr).toFixed(2)}%
                            </Typography>
                          ) : item?.changePercent24Hr > 0 ? (
                            <Typography
                              style={{
                                color: "#54B5BB",
                              }}
                            >
                              <Box
                                component="img"
                                src="/images/incressamount.svg"
                              />
                              {Math.abs(item?.changePercent24Hr).toFixed(2)}%
                            </Typography>
                          ) : (
                            <Typography
                              style={{
                                color: "red",
                              }}
                            >
                              <Box component="img" src="/images/decress.svg" />
                              {Math.abs(item?.changePercent24Hr).toFixed(2)}%
                            </Typography>
                          )}
                        </td>

                        <td>
                          <AccordionSummary
                            sx={style.accordionSummary}
                            aria-controls="panel1a-content"
                          >
                            <GridExpandMoreIcon />
                          </AccordionSummary>
                        </td>
                      </tr>
                    </table>
                    <AccordionDetails sx={style.accordionDetails}>
                      <Table>
                        <TableBody sx={style.tblBody}>
                          <TableRow>
                            <TableCell> Current Price </TableCell>
                            <TableCell width="100px">
                              {country_code == "IN" ? (
                                <>
                                  ₹
                                  {(
                                    Math.round(item?.currentPrice * 80 * 100) /
                                    100
                                  ).toFixed(2)}
                                </>
                              ) : (
                                <>
                                  $
                                  {(
                                    Math.round(item?.currentPrice * 100) / 100
                                  ).toFixed(2)}
                                </>
                              )}
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell> 24hrs Change </TableCell>
                            <TableCell
                              width="100px"
                              style={{
                                color:
                                  item?.return?.returnType == "loss"
                                    ? "red"
                                    : "#54B5BB",
                              }}
                            >
                              {item?.changePercent24Hr == 0 ? (
                                <Typography
                                  style={{
                                    color: "#fff",
                                  }}
                                >
                                  {Math.abs(item?.changePercent24Hr).toFixed(2)}
                                  %
                                </Typography>
                              ) : item?.changePercent24Hr > 0 ? (
                                <Typography
                                  style={{
                                    color: "#54B5BB",
                                  }}
                                >
                                  <Box
                                    component="img"
                                    src="/images/incressamount.svg"
                                  />
                                  {Math.abs(item?.changePercent24Hr).toFixed(2)}
                                  %
                                </Typography>
                              ) : (
                                <Typography
                                  style={{
                                    color: "red",
                                  }}
                                >
                                  <Box
                                    component="img"
                                    src="/images/decress.svg"
                                  />
                                  {Math.abs(item?.changePercent24Hr).toFixed(2)}
                                  %
                                </Typography>
                              )}
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell style={{ width: "50%" }}>
                              <Button
                                sx={style.buyBtn}
                                variant="contained"
                                onClick={() => handleBuyNft(item)}
                              >
                                Buy
                              </Button>{" "}
                            </TableCell>
                            <TableCell style={{ width: "50%" }}>
                              <Button
                                sx={style.sellBtn}
                                variant="contained"
                                onClick={() => handleSellNow(item)}
                              >
                                Sell
                              </Button>
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </AccordionDetails>
                  </Accordion>
                );
              })}
            </>
          ) : (
            <table style={{ width: "100%", tableLayout: "fixed" }}>
              {data?.AlltradingList?.map((item) => {
                return (
                  <tr key={item?.tierId}>
                    <td
                      onClick={() => router?.push(item?.slug)}
                      style={{ cursor: "pointer" }}
                    >
                      <Box
                        component="img"
                        src={item?.defaultImageUrl}
                        style={{
                          width: "40px",
                          height: "40px",
                          borderRadius: "6px",
                          objectFit: "contain",
                        }}
                      />
                      <Typography
                        component="p"
                        style={{ display: "inline-block", marginLeft: "15px" }}
                      >
                        {item?.tierName}{" "}
                      </Typography>
                    </td>
                    <td>
                      {country_code == "IN" ? (
                        <>
                          ₹
                          {(
                            Math.round(item?.currentPrice * 80 * 100) / 100
                          ).toFixed(2)}
                        </>
                      ) : (
                        <>
                          $
                          {(Math.round(item?.currentPrice * 100) / 100).toFixed(
                            2
                          )}
                        </>
                      )}
                    </td>
                    <td>
                      {item?.changePercent24Hr == 0 ? (
                        <Typography
                          style={{
                            color: "#fff",
                          }}
                        >
                          {Math.abs(item?.changePercent24Hr).toFixed(2)}%
                        </Typography>
                      ) : item?.changePercent24Hr > 0 ? (
                        <Typography
                          style={{
                            color: "#54B5BB",
                          }}
                        >
                          <Box
                            component="img"
                            src="/images/incressamount.svg"
                          />
                          {Math.abs(item?.changePercent24Hr).toFixed(2)}%
                        </Typography>
                      ) : (
                        <Typography
                          style={{
                            color: "red",
                          }}
                        >
                          <Box component="img" src="/images/decress.svg" />
                          {Math.abs(item?.changePercent24Hr).toFixed(2)}%
                        </Typography>
                      )}
                    </td>
                    <td>
                      <Button
                        sx={style.buyBtn}
                        variant="contained"
                        onClick={() => handleBuyNft(item)}
                      >
                        Buy
                      </Button>
                      <Button
                        sx={style.sellBtn}
                        variant="contained"
                        onClick={() => handleSellNow(item)}
                      >
                        Sell
                      </Button>
                    </td>
                  </tr>
                );
              })}
            </table>
          )}
        </Box>
      </Box>
    );
  };

  return (
    <Layout color="#0C091B">
      {user?.token && (
        <>
          <Box sx={style.root}>
            <Box sx={style.tabContentBoxPortfolio}>
              <Box sx={style.headingTitle}>
                <Typography component="h1">
                  Trade Activity
                  <Typography
                    component="p"
                    style={{
                      color: "#E14084",
                      display: "inline-block",
                      marginLeft: "10px",
                    }}
                  >
                    Last 24 hours
                  </Typography>
                </Typography>
              </Box>
              <Tabs
                TabIndicatorProps={{ style: { background: "#e14084" } }}
                sx={style.tabContainer}
                value={childvalue}
                onChange={handleChildTabs}
              >
                <Tab
                  label="All"
                  sx={style.tab}
                  style={{
                    backgroundColor: "transparent",
                    marginRight: "16px",
                  }}
                  data-tradingValue="all"
                />
                <img src="/images/tradinggainer.svg" alt="Top gainers" />
                <Tab
                  label="Top Gainers"
                  sx={style.tab}
                  style={{
                    backgroundColor: "transparent",
                    marginRight: "16px",
                  }}
                  data-tradingValue="gain"
                />
                <img src="/images/toplosser.svg" alt="Top Looser" />
                <Tab
                  label="Top Losers"
                  sx={style.tab}
                  style={{ backgroundColor: "transparent" }}
                  data-tradingValue="loss"
                />
              </Tabs>
              <TabPanel
                value={childvalue}
                sx={style.tabPanel}
                index={0}
                style={{ marginBottom: "20px", color: "#fff" }}
              >
                <AllNftTradingData AlltradingList={tradingList} />
              </TabPanel>
              <TabPanel
                value={childvalue}
                sx={style.tabPanel}
                index={2}
                style={{ marginBottom: "20px" }}
              >
                <AllNftTradingData AlltradingList={tradingList} />
              </TabPanel>
              <TabPanel
                value={childvalue}
                sx={style.tabPanel}
                index={4}
                style={{ marginBottom: "20px" }}
              >
                <AllNftTradingData AlltradingList={tradingList} />
              </TabPanel>
            </Box>
          </Box>
          <Footer />
        </>
      )}
    </Layout>
  );
};

function TabPanel(props) {
  const { children, value, index } = props;
  return <div>{value === index && <h1>{children}</h1>}</div>;
}

export default Index;
